import { action, observable } from "mobx";
import { BaseEditViewStore } from "core/stores";
import { NikoPatientDetailService } from "application/niko-patient/services";
import { NikoPatientInsuranceQuestionModalForm } from 'application/niko-patient/forms';
class NikoPatientInsuranceQuestionModalStore extends BaseEditViewStore {
	@observable accessor disabled = false;
	constructor(rootStore, componentProps) {
        const nikoPatientDetail = componentProps.modalParams.data.nikoPatientDetail;
        const nikoPatientDetailService = new NikoPatientDetailService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			name: 'niko-patient-insurance-question-modal',
			Form: NikoPatientInsuranceQuestionModalForm,
			id: nikoPatientDetail.id,
			actions: () => {
				return {
					get: async () => {
						return nikoPatientDetail;
					},
					update: async () => {
						await nikoPatientDetailService.updatePatientInsuranceInfo(this.nikoPatientDetail);
					}
				}
			},
			FormClass: NikoPatientInsuranceQuestionModalForm
		});

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.nikoPatientDetail = nikoPatientDetail;
        this.showTemplateChangeWarning = this.modalParams.data.showTemplateChangeWarning;
    }

	@action.bound
	async resolveInsuranceQuestion() {
		this.disabled = true;
		try {
			this.nikoPatientDetail.insuranceQuestion = null;
			await this.actions.update();
			this.modalParams.close();

			if (this.showTemplateChangeWarning)
				this.showTemplateChangeWarning();
		}
		catch (err) {
			this.disabled = false;
			return this.onUpdateError(err);
		}
	}

	@action.bound
	async updateResource(resource) {
		if (!this.actions.update) return;

		this.form.setFieldsDisabled(true);
		try {
			if (this.translationStore) {
				this.translationStore.applyMetadata(resource);
			}

			this.nikoPatientDetail.insuranceQuestion = resource.insuranceQuestion;
			await this.actions.update();
			this.modalParams.close();

			if (this.showTemplateChangeWarning)
				this.showTemplateChangeWarning();
		}
		catch (err) {
			this.form.setFieldsDisabled(false);
			return this.onUpdateError(err);
		}
	}
}

export default NikoPatientInsuranceQuestionModalStore;